import api from '@/services/utils/base';

export default class BotFilter {
  get(id: string) {
    return api
      .get(`bot-filters/${id}`)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  getList() {
    return api
      .get('bot-filters')
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postCreate(payload: object) {
    return api.post('bot-filters', payload);
  }

  putUpdate(id: string, payload: object) {
    return api.put(`bot-filters/${id}`, payload);
  }

  delete(id: string) {
    return api.delete(`bot-filters/${id}`);
  }

  postArchive(payload: object) {
    return api.post('bot-filters/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('bot-filters/restore', payload);
  }
}
